export default class RateMessageRequest {
  constructor(params) {
    this.rateMessage = {
      message_id: params.message_id,
      gateway_id: params.gateway_id,
      product: params.product,
      currency_code: params.currency_code,
      account_id: params.account_id,
      master_account_id: params.master_account_id,
      originator_number: params.originator_number,
      destination_number: params.destination_number,
      network_code: params.network_code,
    };
    return this.rateMessage;
  }
}
